import { Line } from 'vue-chartjs'
import { mapState } from 'vuex'
import { set } from 'lodash'
import { DEFAULT_PALETTE, DARK_DEFAULT_PALETTE } from '@/lib/colors.js'

export default {
  mixins: [Line],
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
    negativesInPlaceholder: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.render()
  },
  computed: {
    ...mapState(['hideAmounts']),
  },
  watch: {
    hideAmounts() {
      this.render()
    },
  },
  methods: {
    render() {
      let myData, myOptions

      const noData = this.chartData.datasets.every(
        (dataset) => dataset.data.length === 0 || dataset.data.every((item) => item === 0)
      )
      if (!noData) {
        myData = { ...this.chartData }
        myOptions = { ...this.chartOptions }
      } else {
        myData = {
          datasets: [
            {
              data: this.negativesInPlaceholder
                ? [-20, -30, -10, -20, 0, 20, 10, 30, 20]
                : [1000, 2000, 1500, 3000, 2500, 4000, 3500, 5000, 4500],
              borderColor: this.$vuetify.theme.dark
                ? 'rgba(41, 41, 41, 0.4)'
                : 'rgba(247, 248, 251)',
              backgroundColor: this.$vuetify.theme.dark
                ? 'rgba(41, 41, 41, 0.4)'
                : 'rgba(247, 248, 251, 0.7)',
            },
          ],
          labels: ['', '', '', '', '', '', '', '', ''],
        }
        myOptions = {
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  display: false,
                },
              },
            ],
          },
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          hover: { mode: null },
        }
      }

      set(
        myOptions,
        'legend.labels.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )
      set(
        myOptions,
        'scales.xAxes[0].ticks.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )
      set(
        myOptions,
        'scales.yAxes[0].gridLines.color',
        this.$vuetify.theme.dark
          ? DARK_DEFAULT_PALETTE.dark_backgroundLighterBlack
          : DEFAULT_PALETTE.softBackgroundGrey
      )
      set(
        myOptions,
        'scales.yAxes[0].ticks.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )
      set(myOptions, 'scales.yAxes[0].gridLines.drawBorder', false)

      this.renderChart(myData, myOptions)
    },
  },
}
